module.exports = __webpack_public_path__ + "static/media/3DPPA27.630c9afe.jpg";